import { render, staticRenderFns } from "./RightmoveRoI.vue?vue&type=template&id=51603dbe&scoped=true&"
import script from "./RightmoveRoI.vue?vue&type=script&lang=js&"
export * from "./RightmoveRoI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51603dbe",
  null
  
)

export default component.exports